// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { InstrumentTypes } from '../../../../../Utils/Instruments/InstrumentTypes';
import { InstrumentUtils } from '../../../../../Utils/Instruments/InstrumentUtils';
import { type Instrument } from '../../../../../Commons/cache/Instrument';

export class WMSymbolLookupViewItemHelper {
    static getInstrumentTypeShortForInstrument (instrument: Instrument) {
        return WMSymbolLookupViewItemHelper.getInstrumentTypeShort(instrument.InstrType, instrument.CFD);
    }

    static getInstrumentTypeShort (type: any, cfd: boolean): string {
        if (cfd) { return 'CFD'; }

        switch (type) {
        case -1:
            return '';
        case InstrumentTypes.FUTURES:
            return 'FU';
        case InstrumentTypes.FOREX:
            return 'FX';
        case InstrumentTypes.EQUITIES:
            return 'EQ';
        case InstrumentTypes.OPTIONS:
            return 'OPT';
        case InstrumentTypes.CFD_FUTURES:
        case InstrumentTypes.EQUITIES_CFD:
            return 'CFD';
        case InstrumentTypes.INDICIES:
            return 'IND';
        case InstrumentTypes.CRYPTO:
            return 'CRY';
        case InstrumentTypes.PORTFOLIO:
            return 'SI';
        case InstrumentTypes.INS_HISTORY:
            return 'CUS';
        case InstrumentTypes.SPREADBET:
            return 'SB';
        case InstrumentTypes.BOND:
            return 'BND';
        case InstrumentTypes.ETF:
            return 'ETF';
        case InstrumentTypes.TBILL:
            return 'T-B';
        case InstrumentTypes.SPOT:
            return InstrumentUtils.UseFuturesInsteadSpot()
                ? 'FUT'
                : 'SPT';
        case InstrumentTypes.FORWARD:
            return 'FW';
        case InstrumentTypes.CORPORATE:
            return 'COR';
        default:
            return 'GEN';
        }
    }

    static getInstrumentTypeColorForInstrument (instrument: Instrument) {
        return WMSymbolLookupViewItemHelper.getInstrumentTypeColor(instrument.InstrType, instrument.CFD);
    }

    static getInstrumentTypeColor (type: any, cfd: boolean): string {
        if (cfd) { return '#DA80FF'; }

        switch (type) {
        case -1:
            return '';
        case InstrumentTypes.FUTURES:
            return '#FFA531';
        case InstrumentTypes.FOREX:
            return '#329AE1';
        case InstrumentTypes.EQUITIES:
            return '#FF6767';
        case InstrumentTypes.OPTIONS:
            return '#FFFFFF';
        case InstrumentTypes.CFD_FUTURES:
        case InstrumentTypes.EQUITIES_CFD:
            return '#DA80FF';
        case InstrumentTypes.INDICIES:
            return '#FFFD3B';
        case InstrumentTypes.CRYPTO:
            return '#55EFDB';
        case InstrumentTypes.PORTFOLIO:
            return '#FFFD3B';
        case InstrumentTypes.INS_HISTORY:
            return '#FFFD3B';
        case InstrumentTypes.SPREADBET:
            return '#A8DF00';
        case InstrumentTypes.BOND:
            return '#3DA646';
        case InstrumentTypes.ETF:
            return '#96D3FF';
        case InstrumentTypes.TBILL:
            return '#D0D0D0';
        case InstrumentTypes.SPOT:
            return InstrumentUtils.UseFuturesInsteadSpot() === true
                ? '#FFA531'
                : '#26A69A';
        case InstrumentTypes.FORWARD:
            return '#0ED92B';
        case InstrumentTypes.CORPORATE:
            return '#5677FC';
        default:
            return 'white';
        }
    }
}
